import { createActions, createReducer } from 'reduxsauce'

import DespesasPorUnidadeService from '../../servicos/DespesasPorUnidadeService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDespesasPorUnidadeInicio: [],
    buscaDespesasPorUnidadeSucesso: ['despesasPorUnidade'],
    buscaDespesasPorUnidadeErro: ['erro'],
    setDespesasPorUnidadeEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataAtualizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaDespesasPorUnidade = data => {
    return dispatch => {
        dispatch(Creators.buscaDespesasPorUnidadeInicio())
        let serv = new DespesasPorUnidadeService()
        serv.consultar(data)
            .then(response => dispatch(Creators.buscaDespesasPorUnidadeSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDespesasPorUnidadeErro(error)))
    }
}

const buscaDespesasPorUnidadeInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDespesasPorUnidadeErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro })

const buscaDespesasPorUnidadeSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.despesasPorUnidade.resultado, dataAtualizacaoDados: action.despesasPorUnidade.dataAtualizacaoDados, carregando: false }
}

const setDespesasPorUnidadeEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DESPESAS_POR_UNIDADE_INICIO]: buscaDespesasPorUnidadeInicio,
    [Types.BUSCA_DESPESAS_POR_UNIDADE_ERRO]: buscaDespesasPorUnidadeErro,
    [Types.BUSCA_DESPESAS_POR_UNIDADE_SUCESSO]: buscaDespesasPorUnidadeSucesso,
    [Types.SET_DESPESAS_POR_UNIDADE_ESTADO_DT]: setDespesasPorUnidadeEstadoDT,
})
